module.exports = __webpack_public_path__ + "images/status-complete.b73ce30e.png";